<template>
  <v-expansion-panel :disabled="type == 'pending' ? true : false" class="wrapper">
    <v-expansion-panel-header class="wrapper-header">
      <span :class="type == 'private' ? 'dots dots-success mr-1' : 'dots dots-warning mr-1'"></span>
      <!-- <h3 v-if="question.question_fr || question.question_en || question.question_nl" class="mb-2"> -->
      <h3 class="mb-2">
        <pre v-html="question[`question_${$i18n.locale}`]"></pre>
        <!--  -->
      </h3>
    </v-expansion-panel-header>

    <v-expansion-panel-content v-if="type == 'private'">
      <!-- <p v-if="question.answer_fr || question.answer_en || question.answer_nl" class="mb-0"> -->
      <p class="mb-0">
        <pre v-html="question[`answer_${$i18n.locale}`]"></pre>
      </p>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    question: Array | Object,
    type: String
  }
}
</script>

<style scoped>
.wrapper {
  position: relative;
  margin-left: 7px !important;
}
.wrapper.dots {
  position: absolute;
  top: em(10); left: em(-3) !important;
}
</style>
